import { render, staticRenderFns } from "./duty.vue?vue&type=template&id=686c983e&scoped=true&"
import script from "./duty.vue?vue&type=script&lang=js&"
export * from "./duty.vue?vue&type=script&lang=js&"
import style0 from "./duty.vue?vue&type=style&index=0&id=686c983e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686c983e",
  null
  
)

export default component.exports